<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Użytkownicy</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="form.search" class="w-full max-w-md mr-4" @reset="reset">
        <label class="block text-gray-700">Rola:</label>
        <multiselect-input v-model="form.role" class="mt-1 w-full" :options="options" :multiple="false" :close_on_select="true" />
        <label class="mt-4 block text-gray-700">Użytkownicy:</label>
        <select v-model="form.trashed" class="mt-1 w-full form-select">
          <option :value="null" />
          <option value="with">Aktywni i usunięci</option>
          <option value="only">Tylko usunięci</option>
        </select>
      </search-filter>
      <inertia-link class="btn-shtax" :href="route('users.create')">
        <span>Nowy</span>
        <span class="hidden md:inline">użytkownik</span>
      </inertia-link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="px-6 pt-6 pb-4">Nazwa</th>
          <th class="px-6 pt-6 pb-4">Adres e-mail</th>
          <th class="px-6 pt-6 pb-4" colspan="2">Rola</th>
        </tr>
        <tr v-for="user in users" :key="user.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center focus:text-shtax-500" :href="route('users.edit', user.id)">
              <img v-if="user.photo" class="block w-8 h-8 rounded-full mr-2 -my-2" :src="user.photo" />
              {{ user.name }}
              <icon v-if="user.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2" />
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('users.edit', user.id)" tabindex="-1">
              {{ user.email }}
            </inertia-link>
          </td>
          <td class="border-t">
            <inertia-link class="px-6 py-4 flex items-center" :href="route('users.edit', user.id)" tabindex="-1">
              <div v-for="role in user.roles">
                <span class="px-3 py-1 bg-shtax-700 rounded-lg text-white">{{ role.name }}</span>&nbsp;
              </div>
            </inertia-link>
          </td>
          <td class="border-t w-px">
            <inertia-link class="px-4 flex items-center" :href="route('users.edit', user.id)" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </inertia-link>
          </td>
        </tr>
        <tr v-if="users.length === 0">
          <td class="border-t px-6 py-4" colspan="4">Brak użytkowników.</td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/ShtaxComponents/SearchFilter'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'

export default {
  metaInfo: { title: 'Użytkownicy' },
  components: {
    Icon,
    SearchFilter,
    MultiselectInput
  },
  layout: Layout,
  props: {
    filters: Object,
    users: Array,
    roles: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        role: this.filters.role,
        trashed: this.filters.trashed,
      },
      options: this.roles
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function() {
        this.$inertia.get(this.route('users'), pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
